// Your routes — and the navigation binding's, which is the part worth knowing.
//
// THIS FILE IS REPLACED when the navigation shell is re-applied, so commit
// before running `spec apply`.
//
// TWO THINGS ARE CHANGED FROM THE GENERATED VERSION, and they are the same two
// the Overhead build hit (docs/mcp-gaps.md §6 in that repo):
//
// 1. THE ROUTE TREE. The generated tree put `{ path: '/', redirect: HOME }`
//    above the shell, and this plan's primary screen IS '/' — so the app
//    redirected to itself forever and painted nothing. The shell is mounted AT
//    '/' instead, each screen a relative child, and nothing redirects.
//
// 2. THE TABS. The generated bar listed only `primary` screens — one tab, no
//    way to reach anything else. `roles` grades QA importance, not navigation.
//    The five destinations are listed here; message-detail is pushed from the
//    screens that own it and needs no tab.

import { createRouter, createMemoryHistory } from '@ionic/vue-router';
import {
  createOutline, bookOutline, eyeOutline, albumsOutline, settingsOutline,
} from 'ionicons/icons';

import TabsShell from './pages/TabsShell.vue';
import { PRODUCT_ROUTES, HOME_ROUTE } from './product-routes.js';

/** Where the app opens. main.js pushes this. */
export const HOME = HOME_ROUTE;

const ICONS = {
  write: createOutline,
  alphabet: bookOutline,
  decode: eyeOutline,
  saved: albumsOutline,
  settings: settingsOutline,
};

export const TABS = ['write', 'alphabet', 'decode', 'saved', 'settings']
  .map((id) => PRODUCT_ROUTES.find((r) => r.id === id))
  .filter(Boolean)
  .map((r) => ({ name: r.id, label: r.label, path: r.path, icon: ICONS[r.id] }));

export default createRouter({
  history: createMemoryHistory(),
  routes: [
    {
      // The tab shell owns its own outlet, so each tab keeps its own stack.
      path: '/',
      component: TabsShell,
      children: PRODUCT_ROUTES.map((r) => ({
        // Relative, so each screen is a child of the shell. '/' becomes '',
        // which is the index child.
        path: r.path.replace(/^\//, ''),
        name: r.id,
        component: r.component,
        props: true,
      })),
    },
  ],
});
